<template lang="pug">
  .add-step-button(@click="$emit('click')")
    f7-icon(f7="add" size="18")
    label STEPを追加
</template>

<style lang="scss" scoped>
.add-step-button {
  background-color: rgba(255, 255, 255, 0.12);
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

label {
  @extend %body-text;
  margin-left: 9px;
}
</style>

<script>
export default {}
</script>
